import type { IconProps } from "./types";

const defaultProps = {
  svgProps: {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    focusable: false,
    "aria-hidden": true,
  },
  pathProps: {
    fill: "currentColor",
  },
};

const BulletedList = ({
  svgProps = defaultProps.svgProps,
  pathProps = defaultProps.pathProps,
}: IconProps) => {
  const mergedSvgProps = { ...defaultProps.svgProps, ...svgProps };
  const mergedPathProps = { ...defaultProps.pathProps, ...pathProps };
  return (
    <svg {...mergedSvgProps}>
      <path
        d="M4.25 11.4758C3.42 11.4758 2.75 12.1458 2.75 12.9758C2.75 13.8058 3.42 14.4758 4.25 14.4758C5.08 14.4758 5.75 13.8058 5.75 12.9758C5.75 12.1458 5.08 11.4758 4.25 11.4758ZM4.25 5.4758C3.42 5.4758 2.75 6.1458 2.75 6.9758C2.75 7.8058 3.42 8.4758 4.25 8.4758C5.08 8.4758 5.75 7.8058 5.75 6.9758C5.75 6.1458 5.08 5.4758 4.25 5.4758ZM4.25 17.4758C3.42 17.4758 2.75 18.1558 2.75 18.9758C2.75 19.7958 3.43 20.4758 4.25 20.4758C5.07 20.4758 5.75 19.7958 5.75 18.9758C5.75 18.1558 5.08 17.4758 4.25 17.4758ZM7.25 19.9758H21.25V17.9758H7.25V19.9758ZM7.25 13.9758H21.25V11.9758H7.25V13.9758ZM7.25 5.9758V7.9758H21.25V5.9758H7.25Z"
        {...mergedPathProps}
      />
    </svg>
  );
};

export default BulletedList;
